
import ExampleFooter from "../footer/ExampleFooter.jsx";
import ExampleHomePage from "../home/ExampleHomePage.jsx"
import ExampleProductsPage from "../categories/ExampleProductsPage.jsx"
import ExampleBranchesPage from "../branches/ExampleBranchesPage.jsx"
import ExampleJobsPage from "../jobs/ExampleJobsPage.jsx"
import ExampleAboutPage from "../about/ExampleAboutPage.jsx"

export default function ExampleDisplay({page, data, theme}) {
    const displayPage=()=>{
        switch(page){
            case 0: {return <ExampleHomePage data={data} theme={theme}/>}
            case 1: {return <ExampleProductsPage data={data} theme={theme}/>}
            case 2: {return <ExampleBranchesPage data={data} theme={theme}/>}
            case 3: {return <ExampleJobsPage data={data} theme={theme}/>}
            case 4: {return <ExampleAboutPage data={data} theme={theme}/>}
            default: {return <ExampleHomePage data={data} theme={theme}/>}
        }
    }
    return (
        <div className='exampleDisplay'>
            {displayPage()}
            <ExampleFooter theme={theme}/>
        </div>
    )
}
